import { lightShadowBlue } from 'theme/color';

export const offerStatusCont = {
  padding: '8px 10px',
  // borderRadius: "8px",
  // background: lightShadowBlue,
  height: '38px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  background: 'rgba(188, 187, 188, 0.1)',
  border: ' 0.5px solid #E4E4E4',
  borderRadius: '5px',
};
